import { Injectable } from "@angular/core";
import { CONFIGURATION } from "../../app.constants";
import { SecretQuestionAnswers, LostCredentials } from "../../models";
import { Observable } from "rxjs/Observable";
import { HttpDataService } from "../../services/shared";

@Injectable()
export class LostCredentialsService {

    constructor(private httpData: HttpDataService) { }

    public GetSecretQuestionsAnswers(userId: string): Observable<SecretQuestionAnswers> {
        return Observable.create((observer) => {
            this.httpData.get(CONFIGURATION.baseUrls.apiUrl + "Recovery/GetSecretQuestionsAnswers?uid=" + userId)
                .map(response => <SecretQuestionAnswers>response.json().result)
                .subscribe((resData) => {
                    observer.next(resData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

     public IsCorrectQuestionAnswer(secretQuestionAnswers: SecretQuestionAnswers): Observable<boolean> {
        return Observable.create((observer) => {
            this.httpData.post(CONFIGURATION.baseUrls.apiUrl + "Recovery/IsCorrectQuestionAnswer", JSON.stringify(secretQuestionAnswers))
                .map(response => <boolean>response.json().result)
                .subscribe((resData) => {
                    observer.next(resData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

     public Save(lostCredentials: LostCredentials): Observable<LostCredentials> {
        return Observable.create((observer) => {
            this.httpData.post(CONFIGURATION.baseUrls.apiUrl + "Recovery/ChangePassword", JSON.stringify(lostCredentials))
                .map(response => <LostCredentials>response.json())
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/lostCredentials/lostCredentials.service.ts